import { CardImage } from '@curology/ui-components-web/react/Card/CardImage';
import { MediaCard } from '@curology/ui-components-web/react/Card/MediaCard';
import { MediaCardContent } from '@curology/ui-components-web/react/Card/MediaCard/MediaCardContent';
import { Label } from '@curology/ui-components-web/react/Label';
import React from 'react';

const RoutineProducts = () => {
  return (
    <div className="cur-flex cur-my-4">
      <div className="cur-basis-2/4">
        <div className="cur-h-full cur-pr-2">
          <MediaCard>
            <MediaCardContent
              image={
                <CardImage
                  alt="Deep Cleanse Rx product routine image"
                  aspectRatio="4:5"
                  label={<Label labelType="beforeAfter">Cleanse</Label>}
                  src="https://images.ctfassets.net/mdcr7mahi0vp/3QjRDmglANa6odDiqK9jzQ/1000ae0b44592c13649c2286cd2c8219/deep_cleanse_routine.png"
                />
              }
            />
          </MediaCard>
        </div>
      </div>
      <div className="cur-basis-2/4">
        <div className="cur-h-full cur-pl-2">
          <MediaCard>
            <MediaCardContent
              image={
                <CardImage
                  alt="Custom Formula Rx product routine image"
                  aspectRatio="4:5"
                  label={<Label labelType="beforeAfter">Treat</Label>}
                  src="https://images.ctfassets.net/mdcr7mahi0vp/7AW1MHcZx1bLnOG1gUaOyk/5f16a12f934e690250e607f495dfcb51/custom_formula_routine.png"
                />
              }
            />
          </MediaCard>
        </div>
      </div>
    </div>
  );
};

export default RoutineProducts;
